// extracted by mini-css-extract-plugin
module.exports = {"tableRowDropZone":"style_tableRowDropZone__Zaz-A"};